import { defineAsyncComponent } from 'vue'
export default {
  clean: defineAsyncComponent(() => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/layouts/clean.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/layouts/default.vue").then(m => m.default || m)),
  v3: defineAsyncComponent(() => import("/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/layouts/v3.vue").then(m => m.default || m))
}